import { UPDATE_FORM, RESET_FORM } from "../actions/ProgramForm.action";


const today = new Date();
today.setHours(12, 0, 0, 0);

const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
firstDayOfMonth.setHours(12, 0, 0, 0);

const initialState = {
  start_date: firstDayOfMonth,
  end_date: today,
  client_id:"",
  program_ids: [],
  state_ids: [],
  city_ids: [],
};

const ProgramformReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FORM:
      return { ...state, ...action.payload };

    case RESET_FORM:
      return { ...initialState, client_id: state.client_id };

    default:
      return state;
  }
};

export default ProgramformReducer;
